const beforeEnter = (to, from, next) => {
  if (from.name === 'agendamentos' || from.name === 'Agendar Exame') next()
  else next({ name: 'agendamentos' })
}

export default {
  path: '/ficha-clinica',
  component: () => import('@/views/FichaClinica/FichaClinica.vue'),
  meta: { requiresAuth: true, appBar: true, footerMenu: true },
  beforeEnter,
  children: [
    {
      name: 'Ficha Clínica',
      path: '',
      component: () => {
        return import('@/views/FichaClinica/FichaClinicaBemVindo.vue')
      },
      meta: { appBar: true, footerMenu: true }
    },
    {
      path: 'dados',
      component: () => import('@/views/FichaClinica/FichaClinicaDados.vue'),
      meta: { appBar: true, footerMenu: true }
    },
    {
      path: 'perguntas',
      component: () => import('@/views/FichaClinica/FichaClinicaPerguntas.vue'),
      meta: { appBar: true, footerMenu: true }
    },
    {
      path: 'saude',
      component: () => import('@/views/FichaClinica/FichaClinicaSaude.vue'),
      meta: { appBar: true, footerMenu: true }
    },
    {
      path: 'assinatura',
      component: () => import('@/views/FichaClinica/FichaClinicaAssinatura.vue'),
      meta: { appBar: true, footerMenu: true }
    },
    {
      path: 'finalizar',
      component: () => import('@/views/FichaClinica/FichaClinicaFinalizar.vue'),
      meta: { appBar: true, footerMenu: true }
    }
  ]
}
